import { accountProfileUrl, getUser } from '@npm/sso-auth'
import { useEffect, useState } from 'react'

import { get, post } from '../../../client/servers'
import { alertMessage, dialogMessage } from '../../../client/tools/alertMessage'

interface VersionItem {
  name: string
  note: string
}
interface ProductList {
  name: string
  note: string
  versions: VersionItem[]
}

type UserInfo = Awaited<ReturnType<typeof getUser>>
export const useGetLicenses = () => {
  // 产品
  const [product, setProduct] = useState('')
  // 版本
  const [version, setVersion] = useState('')
  // 授权设备MAC地址
  const [macAddress, setMacAddress] = useState('')
  // 申请理由
  const [reason, setReason] = useState('')

  // 错误输入信息
  const [inputMsg, setInputMsg] = useState({
    product: '',
    macAddressList: '',
    reason: ''
  })

  // 产品列表
  const productList: ProductList[] = [
    {
      name: 'GCAir',
      note: 'GCAir10',
      versions: []
    },
    {
      name: 'GCAir8或更早的版本',
      note: 'GCAir8',
      versions: []
    },
    {
      name: 'GCVdyn',
      note: 'GCVdyn',
      versions: []
    },
    {
      name: 'GCSys',
      note: 'GCSys',
      versions: []
    }
  ]

  // 选择产品
  const onProduct = (value: string) => {
    setVersion('')
    setProduct(value)
    if (value.trim() === '') {
      setInputMsg(msg => ({ ...msg, product: '请选择产品' }))
      return false
    }
    setInputMsg(msg => ({ ...msg, product: '' }))
    return true
  }

  // 填写地址
  const onMacAddress = (value = '') => {
    setMacAddress(value)
    const macAddressList = value.split(',').map(item => item.trim())
    for (const item of macAddressList) {
      if (!/^([0-9A-Fa-f]{2}[:-]){5}[0-9A-Fa-f]{2}$/.test(item)) {
        setInputMsg(msg => ({ ...msg, macAddressList: '请输入正确的MAC地址' }))
        return false
      }
    }
    setInputMsg(msg => ({ ...msg, macAddressList: '' }))
    return true
  }

  // 修改理由
  const onsReason = (value = '') => {
    setReason(value)
    if (value.trim() === '') {
      setInputMsg(msg => ({ ...msg, reason: '请输入申请理由' }))
      return false
    }
    if (value.trim().length > 1000) {
      setInputMsg(msg => ({ ...msg, reason: ' 申请理由不能超过1000个字符' }))
      return false
    }
    setInputMsg(msg => ({ ...msg, reason: '' }))
    return true
  }

  // 申请理由
  const [submitLoading, setSubmitLoading] = useState(false)

  // 申请
  const onSubmit = async () => {
    // alertMessage({
    //   msg: '提交成功'
    // })
    // return
    const body = {
      stage: 3,
      type: '试用',
      maxInstance: 5,
      macAddressList: macAddress.split(',').map(item => item.trim()),
      softwareVersion: product,
      expireIn: 4824679210691,
      note: reason
    }
    if (onProduct(product) === false) {
      return
    }
    if (onMacAddress(macAddress) === false) {
      return
    }
    if (onsReason(reason) === false) {
      return
    }
    setSubmitLoading(true)
    const [err] = await post('/api/official_website/licenses', body)
    setSubmitLoading(false)
    if (err) {
      if (err.status === 14000) {
        dialogMessage({
          title: '请完善个人信息',
          digest: '申请使用产品前，需完善必填信息',
          confirm: '马上去完善信息',
          cancel: '取消',
          onConfirm: () => {
            location.href = accountProfileUrl
          }
        })
        return
      }
      alertMessage({
        msg: err.message,
        type: 'error'
      })
    }
    alertMessage({
      msg: '申请成功'
    })
  }

  const loading = true
  const [userInfo, setUserInfo] = useState<UserInfo | boolean | null>(loading)
  // 获取用户信息
  const getMe = () => {
    try {
      void getUser().then(res => {
        setUserInfo(res)
      })
    } catch (e) {
      console.log(e)
      setUserInfo(null)
    }
  }
  useEffect(() => {
    void getMe()
  }, [])

  // 获取是否可以申请
  const getCanApply = async () => {
    try {
      const res = await get<boolean>('/api/official_website/my/isComplete')
      if (res === false) {
        dialogMessage({
          title: '请完善个人信息',
          digest: '申请使用产品前，需完善必填信息',
          confirm: '马上去完善信息',
          cancel: '取消',
          onConfirm: () => {
            location.href = accountProfileUrl
          }
        })
      }
    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    void getCanApply()
  }, [])

  return {
    product,
    setProduct,
    version,
    setVersion,
    macAddress,
    reason,
    setReason,
    productList,
    onProduct,
    onSubmit,
    userInfo,
    submitLoading,
    inputMsg,
    onMacAddress,
    onsReason
  }
}
